import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { TrialLifecycleStateContract } from '../trial-lifecycle.types';

export interface ResolveTrialLifecycleConflictParams {
  trialId: string;
}

export const resolveTrialLifecycleConflict = async ({
  trialId,
}: ResolveTrialLifecycleConflictParams) => {
  const response = await baseAPI.post<TrialLifecycleStateContract>(
    `trialstudents/${trialId}/resolve-lifecycle-conflict`,
  );
  return response.data;
};

export const useResolveTrialLifecycleConflict = () => {
  return useMutation({
    mutationFn: (params: ResolveTrialLifecycleConflictParams) =>
      resolveTrialLifecycleConflict(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_STUDENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_LIFECYCLE_CONFLICTS],
      });
    },
  });
};
